<template>
    <div class="layout-px-spacing dash_1">
        <teleport to="#breadcrumb">
            <ul class="navbar-nav flex-row">
                <li>
                    <div class="page-header">
                        <nav class="breadcrumb-one" aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item"><a href="javascript:;">Dashboard</a></li>
                                <li class="breadcrumb-item active" aria-current="page"><span>Resumo</span></li>
                            </ol>
                        </nav>
                    </div>
                </li>
            </ul>
        </teleport>

        <div class="row layout-top-spacing">
            <div class="col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
                <div class="widget widget-top-selling-products">
                    <div class="widget-heading">
                        <h5>Últimos alertas recebidos</h5>
                    </div>
                    <vue-element-loading :active="isLoadingAlertas" spinner="bar-fade-scale" />

                    <div class="widget-content table-responsive">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>
                                        <div class="th-content">Portal</div>
                                    </th>
                                    <th>
                                        <div class="th-content th-heading">Mensagem</div>
                                    </th>
                                    <th>
                                        <div class="th-content th-heading">Data/Hora</div>
                                    </th>
                                    <th>
                                        <div class="th-content">Registro</div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="dataalertas" v-for="reg in dataalertas" :key="reg.id">
                                    <td>
                                        <div>{{ reg.portal }}</div>
                                    </td>
                                    <td>
                                        <div>{{ reg.msg }}</div>
                                    </td>
                                    <td>
                                        <div><span class="discount-pricing">{{
                                            formataDataHora(reg.DataHoraAlerta) }}</span></div>
                                    </td>
                                    <td>
                                        <div>{{ formataDataHora(reg.DataHoraRegistro) }}</div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div class="col-xl-4 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
                <div class="widget widget-sales-category">
                    <div class="widget-heading">
                        <h5>Alertas dos últimos 7 dias</h5>
                    </div>
                    <vue-element-loading :active="isLoadingBarsAlertas" spinner="bar-fade-scale" />
                    <div class="widget-content">
                        <apex-chart v-if="!isLoadingBarsAlertas" height="460" type="donut" :options="alertas7_dias_options"
                            :series="alertas7_dias_series"></apex-chart>
                    </div>
                </div>
            </div>
        </div>
        

        <div class="row layout-top-spacing">

            <div class="alert alert-icon-left alert-dismissible alert-light-success mb-4" role="alert"
                v-if="msgLogin != '' && !msgLogin.includes('Erro')">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="feather feather-alert-triangle">
                    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z">
                    </path>
                    <line x1="12" y1="9" x2="12" y2="13"></line>
                    <line x1="12" y1="17" x2="12" y2="17"></line>
                </svg>
                <strong>ATENÇÃO!</strong> {{ msgLogin }}
                <button type="button" class="close" data-bs-dismiss="alert" aria-label="Close">×</button>
            </div>
            <div class="alert alert-icon-left alert-dismissible alert-light-danger mb-4" role="alert"
                v-if="msgLogin != '' && msgLogin.includes('Erro')">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="feather feather-alert-circle">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="12" y1="8" x2="12" y2="12"></line>
                    <line x1="12" y1="16" x2="12" y2="16"></line>
                </svg>
                <strong>ATENÇÃO!</strong> {{ msgLogin }}
                <button type="button" class="close" data-bs-dismiss="alert" aria-label="Close">×</button>
            </div>

            <!-- Card externo que agrupa os 3 painéis de desempenho -->
            <div class="col-12 layout-spacing">
                <div class="widget">
                    <!-- Heading com o select de filtro — controla os 3 cards internos -->
                    <div class="widget-heading d-flex align-items-center justify-content-between flex-wrap gap-2">
                        <h5 class="mb-0">Desempenho em pregões</h5>
                        <select v-model="filtroHistorico" @change="AplicaFiltroHistorico" class="form-select form-select-sm" style="max-width:260px;">
                            <option value="andamento">Em andamento + Homologados</option>
                            <option value="homologado">Compra encerrada — Homologada</option>
                        </select>
                    </div>

                    <div class="widget-content">
                        <div class="row">

                            <!-- Card 1: Histórico geral -->
                            <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12 layout-spacing">
                                <div class="widget widget-summary-1">
                                    <div class="widget-heading">
                                        <h5>Histórico geral</h5>
                                    </div>
                                    <vue-element-loading :active="isLoadingRes" spinner="bar-fade-scale" />
                                    <div class="widget-content" v-if="dataTots">
                                        <div class="order-summary">

                                            <!-- Disputou -->
                                            <div class="summary-list summary-income">
                                                <div class="summery-info">
                                                    <div class="w-icon">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                            stroke-linecap="round" stroke-linejoin="round">
                                                            <path d="M9 4H4v4c0 3 2 5 5 5V4z"></path>
                                                            <path d="M15 4h5v4c0 3-2 5-5 5V4z"></path>
                                                            <path d="M8 12h8"></path>
                                                            <path d="M5 20h14"></path>
                                                            <path d="M10 20v-3h4v3"></path>
                                                        </svg>
                                                    </div>
                                                    <div class="w-summary-details">
                                                        <div class="w-summary-info">
                                                            <h6>Disputou <span class="summary-count">{{ dataTots.qntItensParticipou }} itens</span></h6>
                                                            <p class="summary-average">100%</p>
                                                        </div>
                                                        <div class="w-summary-info">
                                                            {{ formatReal(dataTots.totalValorParticipou) }} em lances
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Venceu -->
                                            <div class="summary-list summary-profit">
                                                <div class="summery-info">
                                                    <div class="w-icon">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                            stroke-linecap="round" stroke-linejoin="round">
                                                            <path d="M8 4h8v5a4 4 0 0 1-8 0V4z"></path>
                                                            <path d="M4 6v3c0 4 3 7 8 7s8-3 8-7V6"></path>
                                                            <path d="M10 20h4"></path>
                                                            <path d="M8 16h8"></path>
                                                        </svg>
                                                    </div>
                                                    <div class="w-summary-details">
                                                        <div class="w-summary-info">
                                                            <h6>Venceu <span class="summary-count">{{ dataTots.qntItensGanhou }} itens</span></h6>
                                                            <p class="summary-average">{{ dataTots.porcentagemVitoria }}% de vitória</p>
                                                        </div>
                                                        <div class="w-summary-info">
                                                            {{ formatReal(dataTots.totalFaturado) }} faturados
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Perdeu -->
                                            <div class="summary-list summary-expenses">
                                                <div class="summery-info">
                                                    <div class="w-icon">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                            stroke-linecap="round" stroke-linejoin="round">
                                                            <circle cx="12" cy="12" r="7"></circle>
                                                            <path d="M9 9l3 3 3-3"></path>
                                                            <path d="M10 15h4"></path>
                                                        </svg>
                                                    </div>
                                                    <div class="w-summary-details">
                                                        <div class="w-summary-info">
                                                            <h6>Perdeu <span class="summary-count">{{ dataTots.qntItensPerdeu }} itens</span></h6>
                                                            <p class="summary-average">{{ dataTots.qntItensParticipou > 0 ? (100 - dataTots.porcentagemVitoria).toFixed(1) : 0 }}% dos disputados</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Produto mais vendido -->
                                            <div class="summary-list minhacor" v-if="dataProdMaisVend">
                                                <div class="summery-info">
                                                    <div class="w-icon">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                            stroke-linecap="round" stroke-linejoin="round" class="feather feather-tag">
                                                            <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
                                                            <line x1="7" y1="7" x2="7" y2="7"></line>
                                                        </svg>
                                                    </div>
                                                    <div class="w-summary-details">
                                                        <div class="w-summary-info">
                                                            <h6>Produto mais vendido <span class="summary-count">{{ dataProdMaisVend.nomeProduto }}</span></h6>
                                                            <p class="summary-average">{{ formatReal(dataProdMaisVend.totalValor) }} — {{ dataProdMaisVend.ocorrencias }} pregões</p>
                                                        </div>
                                                        <div class="w-summary-info">
                                                            {{ dataProdMaisVend.totalQuantidade }} unidades no total
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Card 2: Vendas nos últimos 7 dias -->
                            <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12 layout-spacing">
                                <div class="widget widget-summary-1">
                                    <div class="widget-heading">
                                        <h5>Vendas nos últimos 7 dias</h5>
                                    </div>
                                    <vue-element-loading :active="isLoading7Dias" spinner="bar-fade-scale" />
                                    <div class="widget-content" v-if="lucro7Dias">
                                        <apex-chart v-if="!isLoading7Dias" height="400" type="bar" :options="vendas7_options"
                                            :series="vendas7_series"></apex-chart>
                                    </div>
                                </div>
                            </div>

                            <!-- Card 3: Principais concorrentes -->
                            <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12 layout-spacing">
                                <div class="widget widget-visitor-by-browser">
                                    <div class="widget-heading">
                                        <h5>Principais concorrentes</h5>
                                    </div>
                                    <vue-element-loading :active="isLoading5ConcsWn" spinner="bar-fade-scale" />
                                    <div class="widget-content" v-if="data5ConcWin && data5ConcWin.length">
                                        <div class="browser-list" v-for="(item, index) in data5ConcWin" :key="index">
                                            <div class="w-icon icon-fill-primary">
                                                <div class="number-icon">{{ index + 1 }}º</div>
                                            </div>
                                            <div class="w-browser-details">
                                                <div class="w-browser-info">
                                                    <h6>{{ item.razaosocial || item.cnpj }}</h6>
                                                    <p class="browser-count">
                                                        <strong>{{ item.vitorias }}</strong> vitória{{ item.vitorias !== 1 ? 's' : '' }}
                                                        &nbsp;·&nbsp; {{ formatReal(item.valor) }}
                                                    </p>
                                                </div>
                                                <div class="w-browser-stats">
                                                    <div class="progress">
                                                        <div role="progressbar" aria-valuemin="0" aria-valuemax="100"
                                                            :aria-valuenow="maxVitorias > 0 ? Math.round(item.vitorias / maxVitorias * 100) : 0"
                                                            class="progress-bar bg-gradient-primary"
                                                            :style="{ width: (maxVitorias > 0 ? Math.round(item.vitorias / maxVitorias * 100) : 0) + '%' }">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <p v-if="!data5ConcWin.length" class="text-muted text-center mt-3">Nenhum dado disponível ainda</p>
                                    </div>
                                    <div class="widget-content" v-else-if="!isLoading5ConcsWn">
                                        <p class="text-muted text-center mt-3">Nenhum dado disponível ainda</p>
                                    </div>
                                </div>
                            </div>

                            <!-- Card 4: Produtos mais vendidos -->
                            <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12 layout-spacing">
                                <div class="widget widget-summary-1">
                                    <div class="widget-heading d-flex align-items-center justify-content-between flex-wrap gap-2">
                                        <h5 class="mb-0">Produtos mais vendidos</h5>
                                        <select v-model="topProdTipo" @change="PegaTopProdutos()" class="form-select form-select-sm" style="max-width:160px;">
                                            <option value="meus">Meus produtos</option>
                                            <option value="todos">Todos os produtos</option>
                                        </select>
                                    </div>
                                    <vue-element-loading :active="isLoadingTopProd" spinner="bar-fade-scale" />
                                    <div class="widget-content" v-if="!isLoadingTopProd">
                                        <apex-chart v-if="topProdSeries.length" height="340" type="bar"
                                            :options="topProdOptions" :series="topProdSeries" />
                                        <p v-else class="text-muted text-center mt-3">Nenhum dado disponível ainda</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row layout-top-spacing">
            <div class="col-xl-4 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
                <div class="widget widget-sales-category">
                    <div class="widget-heading">
                        <h5>Seus pregões</h5>
                    </div>
                    <vue-element-loading :active="isLoadingBars" spinner="bar-fade-scale" />
                    <div class="widget-content">
                        <apex-chart v-if="!isLoadingBars" height="460" type="donut" :options="sales_donut_options"
                            :series="sales_donut_series"></apex-chart>
                    </div>
                </div>
            </div>

            <div class="col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
                <div class="widget widget-top-selling-products">
                    <div class="widget-heading">
                        <h5>Últimos pregões adicionados</h5>
                    </div>
                    <vue-element-loading :active="isLoadingLista" spinner="bar-fade-scale" />

                    <div class="widget-content table-responsive">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>
                                        <div class="th-content">Portal</div>
                                    </th>
                                    <th>
                                        <div class="th-content th-heading">Objeto</div>
                                    </th>
                                    <th>
                                        <div class="th-content th-heading">Publicação</div>
                                    </th>
                                    <th>
                                        <div class="th-content">Disputa</div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="datalics" v-for="reg in datalics" :key="reg.id">
                                    <td>
                                        <div class="td-content"><span class="pricing">{{ reg.nomeportal }}</span></div>
                                    </td>
                                    <td>
                                        <div class="td-content"><span class="pricing">{{ reg.objeto }}</span></div>
                                    </td>
                                    <td>
                                        <div class="td-content"><span class="discount-pricing">{{
                                            formataData(reg.datapublicacao) }}</span></div>
                                    </td>
                                    <td>
                                        <div class="td-content">{{ formataDataHora(reg.datadisputa) }}</div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import '@/assets/sass/widgets/widgets.scss';
import { computed, ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import ApexChart from 'vue3-apexcharts';
import {
    listaPregoesDash,
    contaAlertas7Dias,
    listaUltimosCad,
    listaTop10Alertas,
    pegaTotaisItens,
    produtoMaisVendido,
    pega5ConcsWinFatu,
    pegaLucro7Dias,
    topProdutos,
    topProdutosTodos,
} from '@/stores/dashStore';
import { formataData, formataDataHora, formatReal } from '@/mixins/fcgeral';
import VueElementLoading from 'vue-element-loading';
import { useMeta } from '@/composables/use-meta';

useMeta({ title: 'Minhas licitações' });

const store = useStore();

const userDados = ref(store.getters.userDados);
const show_wait = ref(false);
const datalics = ref(null);
const dataalertas = ref(null);

const values_lics = ref([]);
const labs_lics = ref([]);
const colors_lics = ref([]);
const values_lics_al = ref([]);
const labs_lics_al = ref([]);
const colors_lics_al = ref([]);

const isLoadingBars = ref(true);
const isLoadingBarsAlertas = ref(true);
const isLoading7Dias = ref(true);
const isLoadingRes = ref(false)
const isLoadingLista = ref(true);
const isLoadingAlertas = ref(true);
const isLoading5ConcsWn = ref(true);
const dataTots = ref(null);
const data5ConcWin = ref(null);
const dataProdMaisVend = ref(null);
const lucro7Dias = ref(null);
const isLoadingTopProd = ref(true);
const topProdSeries = ref([]);
const topProdOptions = ref({});
const topProdTipo = ref('meus'); // 'meus' | 'todos'
const is_dark = computed(() => store.state.is_dark_mode);
const maxVitorias = ref(0);
const msgLogin = ref('');
const filtroHistorico = ref('andamento');


// Sales by Category
const sales_donut_series = ref([]);
const sales_donut_options = ref({});

// Alertas 7 dias
const alertas7_dias_series = ref([]);
const alertas7_dias_options = ref({});

// vendas 7 dias
const vendas7_series = ref([]);
const vendas7_options = ref({});

const updateDonutChartOptions = () => {
    sales_donut_options.value = {
        chart: {
            type: 'donut',
        },
        dataLabels: { enabled: true },
        expandOnClick: !is_dark.value,
        colors: is_dark.value ? ['#5c1ac3', '#e2a03f', '#e7515a', '#e2a03f'] : colors_lics.value,
        legend: {
            position: 'right',
            horizontalAlign: 'center',
            fontSize: '12px',
            markers: { width: 10, height: 10 },
            height: 150,
            offsetY: 20,
            itemMargin: { horizontal: 8, vertical: 0 },
        },
        plotOptions: {
            pie: {
                donut: {
                    size: '65%',
                    background: 'transparent',
                    labels: {
                        show: true,
                        name: { show: true, fontSize: '29px', fontFamily: 'Nunito, sans-serif', offsetY: -5 },
                        value: {
                            show: true,
                            fontSize: '26px',
                            fontFamily: 'Nunito, sans-serif',
                            color: is_dark.value ? '#bfc9d4' : undefined,
                            offsetY: 16,
                            formatter: function (val) {
                                return val;
                            },
                        },
                        total: {
                            show: true,
                            label: 'Total',
                            color: '#888ea8',
                            fontSize: '29px',
                            formatter: function (w) {
                                return w.globals.seriesTotals.reduce(function (a, b) {
                                    return a + b;
                                }, 0);
                            },
                        },
                    },
                },
            },
        },
        labels: labs_lics.value,
    };

    if (is_dark.value) {
        sales_donut_options.value.states = {
            hover: { filter: { type: 'none' } },
            active: { filter: { type: 'none' } },
        };
    }
};

const ListaLicitacoes24H = async () => {
    let json = await listaPregoesDash();
    if (json.ok) {
        let vals = json.data.map((a) => a.total);
        let labs = json.data.map((a) => a.nomeportal);
        let cores = json.data.map((a) => a.cor);

        // Certifique-se de que são arrays
        colors_lics.value = Array.isArray(cores) ? cores : [];
        values_lics.value = Array.isArray(vals) ? vals : [];
        labs_lics.value = Array.isArray(labs) ? labs : [];

        // Atualiza as séries e as opções do gráfico
        sales_donut_series.value = values_lics.value;
        updateDonutChartOptions();
        isLoadingBars.value = false;

    }
};

const updateDonutChartOptionsAlertas = () => {
    alertas7_dias_options.value = {
        chart: {
            type: 'donut',
        },
        dataLabels: { enabled: true },
        expandOnClick: !is_dark.value,
        colors: is_dark.value ? ['#5c1ac3', '#e2a03f', '#e7515a', '#e2a03f'] : colors_lics_al.value,
        legend: {
            position: 'right',
            horizontalAlign: 'center',
            fontSize: '12px',
            markers: { width: 10, height: 10 },
            height: 150,
            offsetY: 20,
            itemMargin: { horizontal: 8, vertical: 0 },
        },
        plotOptions: {
            pie: {
                donut: {
                    size: '65%',
                    background: 'transparent',
                    labels: {
                        show: true,
                        name: { show: true, fontSize: '29px', fontFamily: 'Nunito, sans-serif', offsetY: -5 },
                        value: {
                            show: true,
                            fontSize: '26px',
                            fontFamily: 'Nunito, sans-serif',
                            color: is_dark.value ? '#bfc9d4' : undefined,
                            offsetY: 16,
                            formatter: function (val) {
                                return val;
                            },
                        },
                        total: {
                            show: true,
                            label: 'Total',
                            color: '#888ea8',
                            fontSize: '29px',
                            formatter: function (w) {
                                return w.globals.seriesTotals.reduce(function (a, b) {
                                    return a + b;
                                }, 0);
                            },
                        },
                    },
                },
            },
        },
        labels: labs_lics_al.value,
    };

    if (is_dark.value) {
        alertas7_dias_options.value.states = {
            hover: { filter: { type: 'none' } },
            active: { filter: { type: 'none' } },
        };
    }
};

const ContaAlertas7Dias = async () => {
    show_wait.value = true;
    isLoadingBarsAlertas.value = true;
    let json = await contaAlertas7Dias();

    if (json.ok) {
        let vals = json.data.map((a) => a.total);
        let labs = json.data.map((a) => a.nomeportal);
        let cores = json.data.map((a) => a.cor);

        // Certifique-se de que são arrays
        colors_lics_al.value = Array.isArray(cores) ? cores : [];
        values_lics_al.value = Array.isArray(vals) ? vals : [];
        labs_lics_al.value = Array.isArray(labs) ? labs : [];

        // Atualiza as séries e as opções do gráfico
        alertas7_dias_series.value = values_lics_al.value;
        updateDonutChartOptionsAlertas();
        isLoadingBarsAlertas.value = false;

    }

    show_wait.value = false;
}



const ListaUltimasPortais = async () => {
    show_wait.value = true;
    isLoadingLista.value = true;
    let json = await listaUltimosCad();
    if (json.ok) {
        datalics.value = [...json.data];
        isLoadingLista.value = false;
    }
    show_wait.value = false;
};

const ListaUltimosAlertas = async () => {
    show_wait.value = true;
    isLoadingAlertas.value = true;
    let json = await listaTop10Alertas();
    if (json.ok) {
        dataalertas.value = [...json.data];
        isLoadingAlertas.value = false;
    }
    show_wait.value = false;
}

const PegaTotaisItens = async (filtro = filtroHistorico.value) => {
    isLoadingRes.value = true;
    let json = await pegaTotaisItens(filtro);
    if (json.ok) {
        dataTots.value = json.data;
    }
    isLoadingRes.value = false;
};

const ProdutoMaisVendido = async (filtro = filtroHistorico.value) => {
    let json = await produtoMaisVendido(filtro);
    if (json.ok) {
        dataProdMaisVend.value = json.data;
    }
};

const PegaTopProdutos = async (filtro = filtroHistorico.value) => {
    isLoadingTopProd.value = true;
    const json = topProdTipo.value === 'todos'
        ? await topProdutosTodos(10)
        : await topProdutos(filtro, 10);
    if (json.ok && Array.isArray(json.data) && json.data.length) {
        // API retorna camelCase (nomeProduto, totalValor, ocorrencias, totalQuantidade)
        const items = [...json.data].reverse(); // inverte para o maior ficar no topo do gráfico horizontal
        const labels = items.map(p => {
            const n = p.nomeProduto || '';
            return n.length > 35 ? n.slice(0, 35) + '…' : n;
        });
        const ocorrencias = items.map(p => p.ocorrencias || 0);
        // Guarda valores para exibir no tooltip
        const valoresMap = {};
        items.forEach(p => { valoresMap[p.nomeProduto || ''] = p.totalValor || 0; });

        topProdSeries.value = [{ name: 'Pregões vencidos', data: ocorrencias }];
        topProdOptions.value = {
            chart: { type: 'bar', height: 340, toolbar: { show: false } },
            plotOptions: { bar: { borderRadius: 4, horizontal: true } },
            dataLabels: { enabled: true, formatter: v => v },
            xaxis: {
                categories: labels,
                labels: { style: { fontSize: '10px', fontFamily: 'Nunito, sans-serif' } },
            },
            yaxis: {
                labels: { style: { fontSize: '10px', fontFamily: 'Nunito, sans-serif' } },
            },
            tooltip: {
                custom({ dataPointIndex }) {
                    const p = items[dataPointIndex];
                    const nome = p.nomeProduto || '';
                    const occ = p.ocorrencias || 0;
                    const val = Number(p.totalValor || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
                    const qtd = p.totalQuantidade || 0;
                    return `<div style="padding:8px 12px;font-size:12px;font-family:Nunito,sans-serif">
                        <strong>${nome}</strong><br/>
                        ${occ} pregão(s) vencido(s)<br/>
                        ${val} faturado<br/>
                        ${qtd} unidade(s)
                    </div>`;
                },
            },
            colors: ['#4361ee'],
        };
    } else {
        topProdSeries.value = [];
    }
    isLoadingTopProd.value = false;
};

const AplicaFiltroHistorico = async () => {
    dataTots.value = null;
    dataProdMaisVend.value = null;
    lucro7Dias.value = null;
    isLoading7Dias.value = true;
    isLoadingTopProd.value = true;
    await Promise.all([
        PegaTotaisItens(filtroHistorico.value),
        ProdutoMaisVendido(filtroHistorico.value),
        PegaLucro7Dias(filtroHistorico.value),
        PegaTopProdutos(filtroHistorico.value),
    ]);
};

const Pega5ConcsWinsFatu = async () => {
    let json = await pega5ConcsWinFatu();
    if (json.ok && Array.isArray(json.data)) {
        data5ConcWin.value = json.data;
        maxVitorias.value = json.data.reduce((max, obj) => Math.max(max, obj.vitorias ?? 0), 0);
    }
    isLoading5ConcsWn.value = false;
};

const PegaLucro7Dias = async (filtro = filtroHistorico.value) => {
    let json = await pegaLucro7Dias(filtro);
    if (json.ok) {
        lucro7Dias.value = json.data;

        // Formata data sem fuso (ISO string "2026-04-04T00:00:00" → "04/04")
        const fmtDia = (raw) => {
            const s = raw?.toString() ?? '';
            const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
            return m ? `${m[3]}/${m[2]}` : s;
        };

        // Criar série para o gráfico
        vendas7_series.value = [{
            name: "Faturamento",
            data: lucro7Dias.value.map(item => parseFloat((item.Total ?? item.total ?? 0).toFixed(2)))
        }];

        // Atualizar opções do gráfico com categorias no eixo X
        vendas7_options.value = {
            chart: {
                type: 'bar',
                height: 400,
                toolbar: { show: false }
            },
            plotOptions: {
                bar: { borderRadius: 5, horizontal: false, columnWidth: '55%' },
            },
            dataLabels: { enabled: false },
            stroke: { show: true, width: 2, colors: ['transparent'] },
            xaxis: {
                categories: lucro7Dias.value.map(item => fmtDia(item.Data ?? item.data)),
                labels: {
                    style: { fontSize: '11px', fontFamily: 'Nunito, sans-serif' },
                },
            },
            yaxis: {
                labels: {
                    formatter: (val) => `R$ ${Number(val).toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`
                }
            },
            fill: { opacity: 1 },
            tooltip: {
                y: {
                    formatter: (val) => `R$ ${Number(val).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`
                }
            }
        };

        isLoading7Dias.value = false; // Finaliza carregamento
    } else {
        isLoading7Dias.value = false;
    }
};

onMounted(async () => {
    if (userDados.value.msgAddLogin != "") {
        msgLogin.value = userDados.value.msgAddLogin;
        userDados.value.msgAddLogin = "";
        store.commit('changeUserDados', userDados.value);
    }
    ListaUltimosAlertas();
    ContaAlertas7Dias();
    ListaLicitacoes24H();
    ListaUltimasPortais();
    PegaTotaisItens();
    PegaLucro7Dias();
    Pega5ConcsWinsFatu();
    ProdutoMaisVendido();
    PegaTopProdutos();
});

</script>

<style scoped>
.number-icon {
    font-size: 1.5rem;
    font-weight: bold;
    color: #666;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: #f0f0f0;
}


.summary-list.minhacor {
    background-color: #f0e6f6;
    border-color: #d0a8e8;
}

.summary-list.minhacor .w-icon svg {
    stroke: #7e22ce;
    fill: none;
    width: 24px;
    height: 24px;
}

.summary-list.minhacor h6,
.summary-list.minhacor .summary-count,
.summary-list.minhacor .summary-average {
    color: #5b21b6;
}

/* ── Dark mode: número-ícone dos concorrentes ── */
.dark .number-icon {
    background-color: #1a2036;
    color: #888ea8;
}

/* ── Dark mode: card "produto mais vendido" (roxo) dentro do widget-summary-1 ── */
.dark .summary-list.minhacor {
    background-color: #2a1a3e !important;
    border-color: #5b21b6;
}
.dark .summary-list.minhacor h6,
.dark .summary-list.minhacor .summary-count,
.dark .summary-list.minhacor .summary-average {
    color: #c084fc !important;
}
</style>
